'use strict';

function assign(target/*, sources*/) {
	if (!target) {
		throw new Error('cannot assign to null/undefined!');
	}
	var sources = Array.prototype.slice.call(arguments, 1);
	var source;
	for (var x = 0; x < sources.length; x++) {
		source = sources[x];
		for (var key in source) {
			if (source.hasOwnProperty(key)) {
				target[key] = source[key];
			}
		}
	}
	return target;
}


module.exports = assign;


/*****************
 ** WEBPACK FOOTER
 ** ./src/util/assign.js
 ** module id = 12
 ** module chunks = 0
 **/